import React, { useEffect } from "react";

const SCROLL_HOST_SELECTORS = [
  ".deposit-modal",
  ".crypto-select-window",
  ".crypto-payment-modal",
  ".withdraw-panel",
  ".modal-overlay",
  ".scroll-area",
  "body"
].join(",");

function getScrollHost(el) {
  if (!el) return null;
  let node = el.closest(SCROLL_HOST_SELECTORS);
  if (!node) node = document.scrollingElement || document.documentElement;
  if (node === document.body) node = document.scrollingElement || document.documentElement;
  return node;
}

function highlight(el, on) {
  const block = el.closest(".focus-block") || el.closest(".input-shell") || el;
  if (!block) return;
  block.classList.toggle("focus-accent", !!on);
}

function scrollIntoViewCentered(target) {
  const host = getScrollHost(target);
  if (!host) return;
  const r = target.getBoundingClientRect();
  const hR = host.getBoundingClientRect();
  const centerY = r.top - hR.top - hR.height / 2 + r.height / 2;
  const next = host.scrollTop + centerY;
  host.scrollTo({ top: next, behavior: "smooth" });
}

export default function FocusViewportManager() {
  useEffect(() => {
    const root = document.documentElement;
    const vv = window.visualViewport;

    const updateKb = () => {
      let kb = 0;
      if (vv) {
        const overlap = window.innerHeight - (vv.height + (vv.offsetTop || 0));
        kb = Math.max(0, Math.round(overlap));
      }
      root.style.setProperty("--kb-bottom", `${kb}px`);
      if (kb > 0) document.body.classList.add("kb-open");
      else document.body.classList.remove("kb-open");

      const a = document.activeElement;
      if (!a) return;
      if (a.tagName === "INPUT" || a.tagName === "TEXTAREA" || a.isContentEditable) {
        setTimeout(() => scrollIntoViewCentered(a), 60);
      }
    };

    const onFocusIn = () => {
      const a = document.activeElement;
      if (!a) return;
      if (a.tagName === "INPUT" || a.tagName === "TEXTAREA" || a.isContentEditable) {
        highlight(a, true);
        setTimeout(() => scrollIntoViewCentered(a), 20);
      }
    };

    const onFocusOut = (e) => {
      const t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) {
        highlight(t, false);
      }
    };

    updateKb();
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("focusout", onFocusOut);
    window.addEventListener("resize", updateKb);
    window.addEventListener("orientationchange", updateKb);
    if (vv) {
      vv.addEventListener("resize", updateKb);
      vv.addEventListener("scroll", updateKb);
    }
    return () => {
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("focusout", onFocusOut);
      window.removeEventListener("resize", updateKb);
      window.removeEventListener("orientationchange", updateKb);
      if (vv) {
        vv.removeEventListener("resize", updateKb);
        vv.removeEventListener("scroll", updateKb);
      }
    };
  }, []);

  return null;
}
